import {Reducer} from "redux";
import {Action, ActionTypes} from "../Actions/ActionTypes";
import { ReduxState } from "../Definitions/Definitions";
import { PreloadData } from '../Definitions/Generated/PreloadData';

declare const PRELOAD_DATA: PreloadData;

const initialCurrentUserState = {
    ...PRELOAD_DATA.currentUser,
};

export const CurrentUserReducer: Reducer<ReduxState['currentUser'], Action> = (state = initialCurrentUserState, action) => {
    if(action.type === ActionTypes.SET_CURRENT_USER) {
        return action.currentUser;
    }
    return state;
};

export const AuthenticatedReducer: Reducer<ReduxState['authenticated'], Action> = (state = PRELOAD_DATA.authenticated, action) => {
    if (action.type === ActionTypes.SET_AUTHENTICATED) {
        return action.authenticated;
    }
    return state;
};